import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SimpleCardComponent } from './simple-card.component';

@NgModule({
  declarations: [SimpleCardComponent],
  exports: [SimpleCardComponent],
  imports: [CommonModule]
})
export class SimpleCardModule {}
